import React from 'react';

const AdminContact = () => {
  return <div>AdminContact</div>;
};

export default AdminContact;
